import React from 'react';
import { motion } from 'framer-motion';

const festivalFacts = [
  { label: 'Festival Name', value: 'Synema Interactive Film Festival' },
  { label: 'Dates', value: 'January 21–24, 2027' },
  { label: 'Edition', value: 'Inaugural (1st Edition)' },
  { label: 'Format', value: 'Communal streaming — synchronized global watch parties' },
  { label: 'Platform', value: 'Mindi.TV' },
  { label: 'Total Prize Pool', value: '$12,000 (all cash)' },
  { label: 'Award Categories', value: '17' },
  { label: 'Minimum Prize', value: '$500 per category winner' },
  { label: 'Submission Categories', value: 'Scene, Short, Vertical, Feature, Documentary' },
  { label: 'Website', value: 'synemafest.com' },
];

const Press = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="font-mono text-[0.7rem] tracking-[0.25em] uppercase text-teal mb-4">
            Press
          </div>
          <h1 className="font-display text-[clamp(2.5rem,5vw,4rem)] tracking-[0.04em] leading-none text-white mb-6">
            Press & media.
          </h1>
          <p className="text-[1rem] font-light leading-[1.8] text-white/[0.65] max-w-[640px]">
            For press inquiries, interview requests, and media coverage of Synema Interactive Film Festival.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Festival Facts */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-display text-2xl tracking-[0.05em] text-white mb-6">FESTIVAL FACTS</h2>
            <div className="bg-dark2 border border-white/[0.06] rounded overflow-hidden">
              {festivalFacts.map((fact, i) => (
                <div
                  key={i}
                  className={`flex justify-between items-baseline px-6 py-3 ${
                    i < festivalFacts.length - 1 ? 'border-b border-white/[0.04]' : ''
                  }`}
                >
                  <span className="text-[0.8rem] text-muted">{fact.label}</span>
                  <span className="text-[0.85rem] font-light text-white/70 text-right">{fact.value}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <div className="space-y-8">
            {/* Logo Downloads */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <h2 className="font-display text-2xl tracking-[0.05em] text-white mb-6">LOGO & ASSETS</h2>
              <div className="bg-dark2 border border-white/[0.06] rounded p-8 text-center">
                <div className="font-display text-4xl tracking-[0.04em] nav-logo-gradient mb-4">SYNEMA</div>
                <p className="text-[0.85rem] font-light text-white/50 mb-6">
                  Logo downloads and brand assets will be available here. For immediate needs, contact press.
                </p>
                <div className="text-[0.8rem] text-muted">Press kit coming soon</div>
              </div>
            </motion.div>

            {/* Press Contact */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2 className="font-display text-2xl tracking-[0.05em] text-white mb-6">PRESS CONTACT</h2>
              <div className="bg-dark2 border border-teal/20 rounded p-8">
                <p className="text-[0.95rem] font-light text-white/60 leading-relaxed mb-4">
                  For all press inquiries, interview requests, review screener access, and media partnerships:
                </p>
                <a
                  href="mailto:synemafest@gmail.com"
                  className="text-[1.1rem] font-medium text-teal hover:text-white transition-colors"
                >
                  synemafest@gmail.com
                </a>
                <p className="text-[0.8rem] text-muted mt-3">
                  We aim to respond to all press inquiries within 24 hours.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Press;
